import { FC, useRef } from 'react';
import cs from 'classnames';
import { useMethods } from '@lhb/hook';
import styles from './index.module.less';
import V2Tag from 'src/common/components/Data/V2Tag/index';
import PredictExplanation from './components/PredictExplanation';
import PredictReport from './components/PredictReport/index';

/**
 * 动态表单编辑-AI预测进店率
 * @description
 * @demo
 */
const Component:FC<{
  data?: {
    id?: string|number;
    predictEntryRate?: string;
    predictEntryRateTag?: string;
  };
  disabled?: boolean;
  className?: string;
  complete?: (data: any) => void;
}> = ({ data, disabled, className, complete }) => {

  /* state */

  const predictExplanationRef = useRef<any>(null);
  const predictReportRef = useRef<any>(null);

  /* hooks */

  /* methods */

  const methods = useMethods({

    /** 立即预测 */
    handlePredict() {
      if (disabled) {
        return;
      }
      window.open(`https://single.locxx.ai`);
      // predictExplanationRef.current?.init();
    },

    /** 预测完成 */
    handlePredictComplete(data: any) {
      complete?.(data);
    },

    /** 查看示例 */
    showExample() {
      predictReportRef.current?.init();
    },

    /** 立即查看报告 */
    handleViewReport() {
      predictReportRef.current?.show();
    },

  });

  return (<div className={cs(styles.main, className)}>
    <div className={styles.box}>
      {data && Object.keys(data).length > 0
        ? <div className={styles.content}>
          <div className={styles.rate}>
            <div className={styles.value}>
              <span className={styles.text}>{data?.predictEntryRate}</span>
              <V2Tag color='orange'>{data?.predictEntryRateTag}</V2Tag>
            </div>
            <div className={styles.label}>预计进店率</div>
          </div>
          <div className={styles.report}>
            <div className={styles.title}>
              <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/chancepoint/ai-predict-entry-rate/icon_report_title.png`} className={styles.icon} />
              <span className={styles.text}>预测进店率报告</span>
            </div>
            <div className={cs(styles.button, { [styles.disabled]: disabled })} onClick={methods.handleViewReport}>立即查看</div>
          </div>
        </div>
        : <div className={cs(styles.predict, { [styles.disabled]: disabled })} onClick={methods.handlePredict}>
          <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/chancepoint/ai-predict-entry-rate/bg_content_left.png`} className={styles.bgContentLeft} />
          <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/chancepoint/ai-predict-entry-rate/bg_content_right.png`} className={styles.bgContentRight} />
        </div>
      }
    </div>

    {/* 预测说明 */}
    <PredictExplanation ref={predictExplanationRef} showExample={methods.showExample} />

    {/* 预测报告 */}
    <PredictReport ref={predictReportRef} reload={methods.handlePredict} complete={methods.handlePredictComplete} />

  </div>);
};

export default Component;
